import Vue from "vue";
import App from "./ShopBox.vue";
import store from "./store/index";
import mixin from "./mixin.js";
import VDragged from 'v-dragged'
import vueCustomElement from "vue-custom-element";
import "document-register-element/build/document-register-element";
let infiniteScroll = require("vue-infinite-scroll");
import VueShepherd from "vue-shepherd";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Vue.use(VueShepherd);
Vue.use(infiniteScroll);
Vue.use(vueCustomElement);
Vue.use(VDragged)

App.store = store;
App.store.state.c_page = window.location.pathname;
let sentrySwitch = false
if (process.env.NODE_ENV != 'development' && sentrySwitch) {
  Sentry.init({
    Vue,
    dsn: "https://6334f62003ca4c078257cc89b59a6af6@o774959.ingest.sentry.io/5796755",
    integrations: [new Integrations.BrowserTracing()],

    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      if (hint && hint.originalException) {
        const error = hint.originalException
        if (
          error &&
          error.message.match(/ShopBox/i)
        ) {
          return event;
        } else {
          return null
        }
      } else {
        return null
      }
    },
  });
}

Vue.mixin(mixin);
Vue.customElement("shopbox-app-v2", App);


// Vue.customElement("shopbox-app-v2", App, {
//   shadow: true, beforeCreateVueInstance(root) {
//     const rootNode = root.el.getRootNode();

//     if (rootNode instanceof ShadowRoot) {
//       root.shadowRoot = rootNode;
//     } else {
//       root.shadowRoot = document.head;
//     }
//     return root;
//   },
// });
